module.exports = __webpack_public_path__ + "img/flag3.3ab33194.png";